import { styled } from '@grupoboticario/flora'
import { Box, BoxProps } from '@grupoboticario/flora-react'

export const ImageWrapper = styled('div', {
  cursor: 'grab',
  height: '100%',
  width: '100%',
  maxWidth: '100vw',
  position: 'relative',
})

export const Image = styled(
  ({ src, alt, css, ...props }: BoxProps & { src: string; alt: string }) => (
    <Box
      as="img"
      css={{
        ...css,
        backgroundColor: 'transparent',
        height: '100%',
        width: '100%',
      }}
      src={src}
      alt={alt}
      {...props}
    />
  ),
  {
    backgroundSize: 'contain',
    width: '100%',
  },
)
